/* eslint-disable no-debugger */
import buguang from './buguang/index'
import peijian from './peijian/index'
import shuipei from './shuipei/index'
import zhangpeng from './zhangpeng/index'

const list = [...buguang, ...peijian, ...shuipei, ...zhangpeng];
const data = {};
list.forEach(item => {
	data['key_'+item.name] = item 
})
export default {
	getProduct: (param)=> {
		return data['key_'+param.id]
	},
}

